<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>THE STORY DEVOTIONAL</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ctp" id="p0012-01-0"><a id="page6"></a><a href="#/contents#fn_5" id="sn_5">DAY 5</a></p>
<p class="ct"><a href="#/contents#fn_5">WHAT A MENAGERIE!</a></p>
<p class="ext"><span><i>God said, “Let the land produce living creatures according to their kinds: the livestock, the creatures that move along the ground, and the wild animals, each according to its kind.” And it was so.</i></span></p>
<p class="txr"><span><span class="small">GENESIS</span> 1:24</span></p>
<p class="tx1" id="p0012-04-4"><span class="dcap">W</span>hat critters come to mind when you hear the word <i>livestock</i>? Cows and horses and pigs? What about Brahman bulls and water buffalo and donkeys and llamas? And did you know over eight hundred breeds of cattle are recognized around the world?</p>
<p class="tx">What do you think of when you hear the words <i>wild animals</i>? Don’t limit yourself to lions and tigers and bears. What about manatees, platypi, and anteaters?</p>
<p class="tx">Then there are those members of the animal world you’ve probably never met: the blobfish, the aye-aye, the star-nosed mole, the three-foot, coconut-eating coconut crab, and the list goes on. The creativity God used in designing the animal kingdom is only a fraction of the energy he used in making you.</p>
<p class="tx2">THE CARE GOD EXERCISED IN CRAFTING YOU IS THE PINNACLE OF GOD’S CREATIVE CRAFTSMANSHIP, CARE, AND JOY! </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter8.vue?0c8e3b5d